module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ep-tag', {
      'ep-tag-border': _vm.border
    }]
  }, [_c('div', {
    staticClass: "ep-tag-con",
    style: ({
      'left': _vm.groupLeft + 'px'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e53bdf8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/tags/src/tag.vue
// module id = 1191
// module chunks = 2